/**
 * 지식 보기 모달
 * 지식 상세 내용 표시 (Markdown 렌더링)
 */

import React from 'react';
import { useKnowledge } from '../../contexts/KnowledgeContext';
import './KnowledgeViewModal.css';

/**
 * 간단한 Markdown 렌더러
 */
function renderMarkdown(text) {
  if (!text) return '';

  let html = text
    // 코드 블록
    .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
    // 인라인 코드
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // 굵게
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    // 기울임
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    // 제목
    .replace(/^### (.+)$/gm, '<h4>$1</h4>')
    .replace(/^## (.+)$/gm, '<h3>$1</h3>')
    .replace(/^# (.+)$/gm, '<h2>$1</h2>')
    // 링크
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    // 목록
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    // 줄바꿈
    .replace(/\n/g, '<br/>');

  // li 태그를 ul로 감싸기
  html = html.replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>');

  return html;
}

function KnowledgeViewModal({ item, onClose, onEdit }) {
  const { categories } = useKnowledge();
  const category = categories[item.category] || categories.general_notes;

  // 복사 핸들러
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(item.content);
      alert('내용이 복사되었습니다.');
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  // 날짜 포맷
  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="knowledge-view-modal" onClick={e => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="view-header">
          <div className="view-category" style={{ backgroundColor: category.color }}>
            {category.icon} {category.label}
          </div>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>

        {/* 제목 */}
        <h2 className="view-title">
          {item.isFavorite && <span className="favorite-badge">⭐</span>}
          {item.title}
        </h2>

        {/* 메타 정보 */}
        <div className="view-meta">
          <span>우선순위: {item.priority}/10</span>
          <span>생성: {formatDate(item.createdAt)}</span>
          <span>수정: {formatDate(item.updatedAt)}</span>
        </div>

        {/* 태그 */}
        {item.tags && item.tags.length > 0 && (
          <div className="view-tags">
            {item.tags.map((tag, idx) => (
              <span key={idx} className="tag">{tag}</span>
            ))}
          </div>
        )}

        {/* 내용 */}
        <div
          className="view-content"
          dangerouslySetInnerHTML={{ __html: renderMarkdown(item.content) }}
        />

        {/* 액션 버튼 */}
        <div className="view-actions">
          <button onClick={handleCopy}>
            📋 복사
          </button>
          <button onClick={onEdit}>
            ✎ 수정
          </button>
          <button onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}

export default KnowledgeViewModal;
